export const PYTHON_API_AUTH_TOKEN_KEY = "mp_id_token"
export const AUTH_CUSTOM_TOKEN_KEY = "mp_customToken"
export const UM_TABLE_COLUMNS = "mp_um_table_columns"
export const EOC_CURRENT_PROGRAM_KEY = "mp_eoc_current_program"
export const CURRENT_PROGRAM_KEY = "mp_current_program"

// Pentest finding #2 (JWTs Stored in Local Storage): auth credentials must
// never be persisted in Web Storage, where any script on the page can read
// them. These keys are held in module memory only for the life of the page;
// callers keep using storage.get/set/remove unchanged.
const MEMORY_ONLY_KEYS = new Set([
  PYTHON_API_AUTH_TOKEN_KEY,
  AUTH_CUSTOM_TOKEN_KEY
])
const memoryStore = new Map()

// Purge copies written by earlier builds so upgraded browsers don't keep a
// stale token lying around in localStorage.
try {
  MEMORY_ONLY_KEYS.forEach(key => localStorage.removeItem(key))
} catch (_e) {
  // localStorage unavailable (private mode, etc.) – nothing to purge
}

export const clearSessionTokens = () => {
  memoryStore.clear()
}

const storage = {
  get: key => {
    if (MEMORY_ONLY_KEYS.has(key)) return memoryStore.get(key) ?? null
    return localStorage.getItem(key)
  },
  set: (key, value) => {
    if (MEMORY_ONLY_KEYS.has(key)) {
      memoryStore.set(key, value)
      return
    }
    localStorage.setItem(key, value)
  },
  remove: key => {
    if (MEMORY_ONLY_KEYS.has(key)) {
      memoryStore.delete(key)
      return
    }
    localStorage.removeItem(key)
  },
  clear: () => {
    memoryStore.clear()
    localStorage.clear()
  }
}

export default storage
